import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import reducer from './duck';
import App from './components/app';
import OptionsContext from './contexts/options';

const { addReducers } = window.reduxState;

const FeaturedComponent = ({ componentId }) => {
  const namespacedStateEntry = `featuredBets-${componentId}`;

  addReducers({
    [namespacedStateEntry]: reducer(namespacedStateEntry),
  });

  const contextValue = useMemo(() => ({ namespacedStateEntry }), [namespacedStateEntry]);

  return (
    <OptionsContext.Provider value={contextValue}>
      <App componentId={componentId} />
    </OptionsContext.Provider>
  );
};

FeaturedComponent.propTypes = {
  componentId: PropTypes.number.isRequired,
};

export default FeaturedComponent;
